import { ID_TYPE_PRODUCT_ATTRIBUTE } from '@shared/constants/keys';
import { ProductsType } from '@shared/types/product';

export const distributionByCategory = (products: ProductsType): Record<string, ProductsType> => {
  const result: Record<string, ProductsType> = {};

  if (products && Object.keys(products).length) {
    Object.keys(products).forEach((key) => {
      const category = products[key].props[ID_TYPE_PRODUCT_ATTRIBUTE].values[0].value;

      if (!result[category]) {
        result[category] = {};
      }

      result[category][key] = products[key];
    });
  }

  return result;
};
